import { CourseDef } from '../../../../types';
import L2079374 from './2079374';
import L3893644 from './3893644';
import L4454332 from './4454332';
// import L5234406 from './5234406';
import L5234407 from './5234407';

export const mindsetDoTrader: CourseDef = {
  courseTitle: 'MINDSET DO TRADER',
  lessons: [
    L2079374,
    L3893644,
    L4454332,
    // L5234406,
    L5234407,
  ],
};

